import * as ACTIONS from "./../actions/types"

// A reducer to hold data about the devices

const defaultState = {
  byID: {}, // Sort out the devices by ID
  allIDs: []
}

const deviceReducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case ACTIONS.FETCH_DEVICES_SUCCESS:
      return { ...state, byID: payload, allIDs: Object.keys(payload) }

    case ACTIONS.REPLACE_DEVICES:
      return {
        ...state,
        byID: payload,
        allIDs: Object.keys(payload)
      }

    default:
      return state
  }
}

export default deviceReducer
